import api from "../apis/api";

class NotesService {
    createNoteService(req) {
        return api.notes.createNote(req);
    }

    updateNoteService(req) {
        return api.notes.updateNote(req);
    }

    deleteNoteService(req) {
        return api.notes.deleteNote(req);
    }
}
export default new NotesService();
